import Head from "next/head";
import configUrl from "../config/config.json";

const PageSeo = ({ children }) => {
  return (
    <Head>
      <title>{children?.props?.home?.data?.data?.seo?.title}</title>
      {children?.props?.home?.data?.data?.seo?.metadata.map((element, idx) => {
        if (element.attribute == "property") {
          return (
            <meta
              key={"metadata" + idx}
              property={element.tag}
              content={element.content}
            ></meta>
          );
        } else if (element.attribute == "http-equiv") {
          return (
            <meta
              key={"metadata" + idx}
              http-equiv={element.tag}
              content={element.content}
            ></meta>
          );
        } else {
          return (
            <meta
              key={"metadata" + idx}
              name={element.tag}
              content={element.content}
            ></meta>
          );
        }
      })}

      <link
        rel="canonical"
        href={children?.props?.home?.data?.data?.seo?.url}
      />
      {/* Pwa Tags */}
      {children?.props?.home?.data?.site?.allow_pwa_module == true && (
        <link rel="manifest" href={"/shared/api/pwa/manifest"} />
      )}
      {/* <link rel="manifest" href="/manifest.json" /> */}

      {/* Pwa Tags for Android  */}
      {/* <meta name="theme-color" content="#fff" /> */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="full-screen" content="yes" />

      {/* Pwa Tags for iOS */}
      <meta name="apple-touch-fullscreen" content="yes"></meta>
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta
        name="apple-mobile-web-app-title"
        content={children?.props?.home?.data?.data?.seo?.title}
      />
      <meta name="format-detection" content="telephone=no" />

      {/* Pwa Icons for iOS */}
      {/* <link
        rel="apple-touch-icon"
        href={`${
          children?.props?.home?.data?.data?.seo?.base_url +
          "/shared/api/media/" +
          children?.props?.home?.data?.data?.header?.logo
        }`}
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href={`${
          children?.props?.home?.data?.data?.seo?.base_url +
          "/shared/api/media/" +
          children?.props?.home?.data?.data?.header?.logo
        }`}
      />
      <link
        rel="apple-touch-icon"
        sizes="167x167"
        href={`${
          children?.props?.home?.data?.data?.seo?.base_url +
          "/shared/api/media/" +
          children?.props?.home?.data?.data?.header?.logo
        }`}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${
          children?.props?.home?.data?.data?.seo?.base_url +
          "/shared/api/media/" +
          children?.props?.home?.data?.data?.header?.logo
        }`}
      /> */}

      {/*  Main Link Tags */}
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={
          "/shared/api/media/" +
          children.props?.home?.data?.data?.site_id +
          "/" +
          children?.props?.home?.data?.site?.favicon
        }
      />

      {/* dynamic linkdata icons */}
      {children?.props?.home?.data?.data?.seo?.linkdata &&
        children?.props?.home?.data?.data?.seo?.linkdata.map((element, idx) => {
          return (
            <link
              key={"link" + idx}
              rel={element.rel}
              type={element.type}
              size={element.size.width + "x" + element.size.height}
              href={element.href}
            ></link>
          );
        })}
    </Head>
  );
};

export default PageSeo;
